/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from "@/shared/api/axiosInstance";
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from "@/shared/api/axiosInstance";
import type {
  GetApiV1PersonIdBasicDataQueryResponse,
  GetApiV1PersonIdBasicDataPathParams,
  GetApiV1PersonIdBasicData401,
  GetApiV1PersonIdBasicData404,
  GetApiV1PersonIdBasicData500,
} from "../../types/personRegisterController/GetApiV1PersonIdBasicData.ts";

function getGetApiV1PersonIdBasicDataUrl(
  id: GetApiV1PersonIdBasicDataPathParams["id"],
) {
  const res = {
    method: "GET",
    url: `/api/v1/person/${id}/basic-data` as const,
  };
  return res;
}

/**
 * @description Retorna os dados básicos de uma pessoa (nome, e-mail, nascimento, nacionalidade). **(Requer Authorization para autenticação)**
 * @summary Obter dados básicos (Requer Authorization para autenticação)
 * {@link /api/v1/person/:id/basic-data}
 */
export async function getApiV1PersonIdBasicData(
  id: GetApiV1PersonIdBasicDataPathParams["id"],
  config: Partial<RequestConfig> & { client?: Client } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    GetApiV1PersonIdBasicDataQueryResponse,
    ResponseErrorConfig<
      | GetApiV1PersonIdBasicData401
      | GetApiV1PersonIdBasicData404
      | GetApiV1PersonIdBasicData500
    >,
    unknown
  >({
    method: "GET",
    url: getGetApiV1PersonIdBasicDataUrl(id).url.toString(),
    ...requestConfig,
  });
  return res.data;
}
